import { render, staticRenderFns } from "./PacponNaCto.vue?vue&type=template&id=1ba2bdc4&scoped=true&"
import script from "./PacponNaCto.vue?vue&type=script&lang=js&"
export * from "./PacponNaCto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2bdc4",
  null
  
)

export default component.exports